import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CautionFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="m21.63 18.84-4.33-7.41-4.24-7.26c-.46-.78-1.67-.78-2.12 0L6.7 11.43l-4.33 7.41c-.44.75.15 1.66 1.06 1.66h17.14c.92 0 1.5-.91 1.06-1.66Zm-8.78-1.6c-.19.2-.44.3-.73.3s-.54-.1-.74-.3c-.19-.2-.29-.44-.29-.73s.1-.53.29-.73c.19-.2.44-.3.74-.3s.53.1.73.3c.19.2.29.44.29.73s-.1.53-.29.73Zm.4-6.1-.56 3.29c-.02.18-.08.33-.19.42-.1.1-.23.15-.38.15s-.27-.05-.38-.15c-.1-.1-.17-.24-.2-.42l-.55-3.3s-.01-.1-.01-.17c0-.32.11-.57.32-.75.22-.18.49-.27.81-.27.32 0 .61.09.82.28.21.18.32.44.32.75 0 .07 0 .13-.01.17h.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CautionFilled
